import React from "react";
import { Component } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, CartesianAxis, Tooltip,  LabelList, ResponsiveContainer } from 'recharts';
import CustomRegionTooltip from "./cost-line-tooltip.component";

export class CostLineChartData extends Component {
    constructor(props) {
      super(props);
      this.state={
        lineColors:"",
      }
    }
    render(){
      const {data}=this.props;    
     
      
        return(
        <div className="width-p100">
            <ResponsiveContainer width="100%" height={400}>
          <LineChart
         
            width={500}
            height={200}                 
            margin={{
              top: 10,
              right: 20,
              left: -50,
              bottom: 0,
            }}
          >
            <CartesianGrid  stroke="#dfe3e8" horizontal={false} />
         
            <XAxis axisLine={false} stroke="#dfe3e8" tick={{fontSize: 11, fill: '#919eab'}} dataKey="name" type="number" />
            <YAxis axisLine={false} tickLine={false} stroke="#dfe3e8" tick={false} />   
           <Tooltip content={<CustomRegionTooltip/>} />
            {data.map((item,id)=>
                <Line dataKey="pv" stroke={item[0].linecolor} fill={item[0].linecolor} data={item} key={id}/>
            )}
           
          </LineChart>
        </ResponsiveContainer>
        </div>
        );
    }
}

